import React from 'react';

import { Container } from './styles';

export default function Print() {
  return (
    <Container>
      <div id="print" />
    </Container>
  );
}
